import {
  Button,
  Card,
  Modal,
  ModalCloseButton,
  Section,
  SectionSubtitle,
  SectionText,
  SectionTitle,
} from '@presentation/components';
import type { FC } from 'react';
import { useRouter } from '@application/utils';
import { TbArrowRight } from 'react-icons/tb';
import type { MtBreederStorePartnershipModalProps } from './types';
import breederPartnershipImageFr from './assets/breederPartnershipFr.webp';
import breederPartnershipImageNl from './assets/breederPartnershipNl.webp';
import breederPartnershipImageDe from './assets/breederPartnershipDe.webp';
import * as Styled from './styled';

export * from './types';

const illustrativePicture = {
  fr: breederPartnershipImageFr,
  nl: breederPartnershipImageNl,
  de: breederPartnershipImageDe,
  en: breederPartnershipImageFr,
};
export const MtBreederStorePartnershipModal: FC<MtBreederStorePartnershipModalProps> = (props) => {
  const { modal, onConfirm } = props;

  const { translate, language } = useRouter();

  const image = illustrativePicture[language];
  return (
    <Modal {...modal}>
      <Card size="small" isModal>
        <ModalCloseButton modal={modal} />
        <Section centerChildren>
          <SectionTitle>{translate('common.modals.breederStorePartnership.title')}</SectionTitle>
          <Styled.Image src={image} />
          <SectionText>{translate('common.modals.breederStorePartnership.text')}</SectionText>
        </Section>

        <Section centerChildren>
          <Button
            onClick={onConfirm}
            color="blue"
            size="medium"
            iconRight={<TbArrowRight />}
            shrink
          >
            {translate('common.modals.breederStorePartnership.cta')}
          </Button>
        </Section>
      </Card>
    </Modal>
  );
};
